import React from 'react';

import classes from './CardMenu.module.css';
import RightArrowIcon from '../../../../assets/icons/icon-right-filled-black.svg';
import DropdownMenuIcon from '../../../../assets/icons/dropdown_menu_blue.png';

// const CardMenu = (props) => {

//     return (
//         <div className={classes.CardMenuContainer}>
//             <div className={classes.MenuIconDiv}>
//                 {/* <span></span><span></span><span></span> */}
//                 <img src={DropdownMenuIcon} className={classes.MenuIcon} />
//             </div>
//             <div className={classes.FirstMenu}>
//                 <div className={classes.NewUnitDiv}>
//                     <div className={classes.MenuItem}>Add New Unit
//                     <img src={RightArrowIcon} className={classes.ArrowIcon} />
//                     </div>
//                 </div>
//                 <p className={classes.MenuItem}>Mark Day As Off</p>
//                 <p className={classes.MenuItem}>Clear All</p>

//                 <div className={classes.SecondMenu}>
//                     <p className={classes.MenuItem}>Topic</p>
//                     <p className={classes.MenuItem}>Quiz</p>
//                     <p className={classes.MenuItem}>Assignment</p>
//                 </div>
//             </div>
//         </div>
//     );
// }

class CardMenu extends React.Component {

    state = {
        showFirstMenu: false,
        showSecondMenu: false,
        menuItemClicked: false
    }

    showSecondMenu = () => {
        let status = this.state.showSecondMenu;

        this.setState({ showSecondMenu: !status, showFirstMenu: true, menuItemClicked: true });
    }

    componentDidMount() {
        this.setState({ showFirstMenu: this.props.show, showSecondMenu: false });
    }

    render() {
        return (
            <div className={classes.CardMenuContainer}>
                {
                    this.state.showFirstMenu
                        ? <div className={classes.FirstMenu}>
                            <div className={classes.NewUnitDiv} onClick={this.showSecondMenu}>
                                <div className={classes.MenuItem}>Add New Unit
                                    <img src={RightArrowIcon} className={classes.ArrowIcon} />
                                </div>
                            </div>
                            <p className={classes.MenuItem} onClick={this.props.markDayOffClicked}>Mark Day As Off</p>
                            {/* <p className={classes.MenuItem} onClick={this.props.clearAllClicked}>Clear All</p> */}

                            {
                                this.state.showSecondMenu
                                    ? <div className={classes.SecondMenu}>
                                        <p className={classes.MenuItem} onClick={this.props.createNewTopicClicked}>Topic</p>
                                        <p className={classes.MenuItem} onClick={this.props.createNewQuizClicked}>Quiz</p>
                                        <p className={classes.MenuItem} onClick={this.props.createNewAssignmentClicked}>Assignment</p>
                                    </div>
                                    : null
                            }
                        </div>
                        : null
                }
            </div>
        )
    }
}

export default CardMenu;